const SULLIVAN_ON_COMP_ROOT_HOST = 'sullivanoncomp.com';
const PRECEDENT_CASES_HOST = 'soc-precedent-cases-production.s3.us-west-1.amazonaws.com';
const LEGAL_CODE_PATHNAME = '/external_resources';

function normalizeHostname(hostname: string): string {
  const lowerHostname = hostname.toLowerCase();
  return lowerHostname.endsWith('.') ? lowerHostname.slice(0, -1) : lowerHostname;
}

function isSullivanOnCompHostname(hostname: string): boolean {
  const normalizedHostname = normalizeHostname(hostname);
  return normalizedHostname === SULLIVAN_ON_COMP_ROOT_HOST
    || normalizedHostname.endsWith(`.${SULLIVAN_ON_COMP_ROOT_HOST}`);
}

function parseHttpsUrl(value?: string): URL | undefined {
  if (!value) return;
  try {
    const parsed = new URL(value);
    return parsed.protocol === 'https:' ? parsed : undefined;
  } catch {
    return;
  }
}

export function isSullivanOnCompUrl(value?: string): boolean {
  const parsed = parseHttpsUrl(value);
  return !!parsed && isSullivanOnCompHostname(parsed.hostname);
}

export function isLegalCodeUrl(value?: string): boolean {
  const parsed = parseHttpsUrl(value);
  if (!parsed || !isSullivanOnCompHostname(parsed.hostname)) return false;
  const normalizedPathname = parsed.pathname.toLowerCase().replace(/\/+$/, '');
  return normalizedPathname === LEGAL_CODE_PATHNAME;
}

export function getTrustedCaseUrl(value?: string): string | undefined {
  const parsed = parseHttpsUrl(value);
  if (!parsed) return;

  const hostname = normalizeHostname(parsed.hostname);
  if (isSullivanOnCompHostname(hostname) || hostname === PRECEDENT_CASES_HOST) {
    return parsed.toString();
  }
}
